import {ECurrency} from '@edna/utils';

import {EChannelType, TItemId} from 'src/constants';
import {ERoles} from 'src/containers/User';

export enum EUserCompanyProfileTabs {
  PAYMENT = 'payment',
  LICENSE = 'license',
  REQUISITES = 'requisites',
  MAILINGS = 'mailings',
  USERS = 'users',
}

export const TABS = Object.values(EUserCompanyProfileTabs);

export enum ETemporaryBlockedTypes {
  BROADCASTS = 'BROADCASTS',
  TEMPLATES = 'TEMPLATES',
  CHANNELS = 'CHANNELS',
  CASCADES = 'CASCADES',
  OTHER = 'OTHER',
}

export enum EMailingsCategory {
  CHANNELS_EMAIL_NOTIFICATIONS = 'CHANNELS_EMAIL_NOTIFICATIONS',
  TEMPLATES_EMAIL_NOTIFICATIONS = 'TEMPLATES_EMAIL_NOTIFICATIONS',
  LICENSE_EMAIL_NOTIFICATIONS = 'LICENSE_EMAIL_NOTIFICATIONS',
  PAYKEEPER_EMAIL_NOTIFICATIONS = 'PAYKEEPER_EMAIL_NOTIFICATIONS',
  STRIPE_EMAIL_NOTIFICATIONS = 'STRIPE_EMAIL_NOTIFICATIONS',
  BALANCE_EMAIL_NOTIFICATIONS = 'BALANCE_EMAIL_NOTIFICATIONS',
  TENANT_ACCESS_EMAIL_NOTIFICATIONS = 'TENANT_ACCESS_EMAIL_NOTIFICATIONS',
}

export enum EMailingSubcategory {
  // CHANNELS_EMAIL_NOTIFICATIONS
  REGISTRATION_OK_NOTIFY_CHANNEL_EMAIL = 'REGISTRATION_OK_NOTIFY_CHANNEL_EMAIL',
  REGISTRATION_VK_NOTIFY_CHANNEL_EMAIL = 'REGISTRATION_VK_NOTIFY_CHANNEL_EMAIL',
  REGISTRATION_WHATSAPP_CHANNEL_EMAIL = 'REGISTRATION_WHATSAPP_CHANNEL_EMAIL',
  RESTRICTIONS_WABA_EMAIL = 'RESTRICTIONS_WABA_EMAIL',
  CHANGE_QUALITY_WHATSAPP_CHANNEL_EMAIL = 'CHANGE_QUALITY_WHATSAPP_CHANNEL_EMAIL',
  REGISTRATION_VIBER_CHANNEL_EMAIL = 'REGISTRATION_VIBER_CHANNEL_EMAIL',
  REGISTRATION_SMS_CHANNEL_EMAIL = 'REGISTRATION_SMS_CHANNEL_EMAIL',
  REGISTRATION_MAX_BOT_CHANNEL_EMAIL = 'REGISTRATION_MAX_BOT_CHANNEL_EMAIL',
  REGISTRATION_MAX_CHANNEL_EMAIL = 'REGISTRATION_MAX_CHANNEL_EMAIL',
  REGISTRATION_TG_CHANNEL_EMAIL = 'REGISTRATION_TG_CHANNEL_EMAIL',
  // TEMPLATES_EMAIL_NOTIFICATIONS
  REGISTRATION_VK_NOTIFY_TEMPLATE_EMAIL = 'REGISTRATION_VK_NOTIFY_TEMPLATE_EMAIL',
  REGISTRATION_OK_NOTIFY_TEMPLATE_EMAIL = 'REGISTRATION_OK_NOTIFY_TEMPLATE_EMAIL',
  REGISTRATION_SMS_TEMPLATE_EMAIL = 'REGISTRATION_SMS_TEMPLATE_EMAIL',
  REGISTRATION_VIBER_TEMPLATE_EMAIL = 'REGISTRATION_VIBER_TEMPLATE_EMAIL',
  REGISTRATION_WHATSAPP_TEMPLATE_EMAIL = 'REGISTRATION_WHATSAPP_TEMPLATE_EMAIL',
  CHANGE_WHATSAPP_TEMPLATE_EMAIL = 'CHANGE_WHATSAPP_TEMPLATE_EMAIL',
  DISABLE_WHATSAPP_TEMPLATE_EMAIL = 'DISABLE_WHATSAPP_TEMPLATE_EMAIL',
  // LICENSE_EMAIL_NOTIFICATIONS
  SMS_LICENSE_STATUS_EMAIL = 'SMS_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_SMS_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_SMS_LICENSE_EMAIL',
  VIBER_LICENSE_STATUS_EMAIL = 'VIBER_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_VIBER_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_VIBER_LICENSE_EMAIL',
  WHATSAPP_LICENSE_STATUS_EMAIL = 'WHATSAPP_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_WHATSAPP_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_WHATSAPP_LICENSE_EMAIL',
  MAX_BOT_LICENSE_STATUS_EMAIL = 'MAX_BOT_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_MAX_BOT_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_MAX_BOT_LICENSE_EMAIL',
  MAX_LICENSE_STATUS_EMAIL = 'MAX_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_MAX_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_MAX_LICENSE_EMAIL',
  TG_LICENSE_STATUS_EMAIL = 'TG_LICENSE_STATUS_EMAIL',
  NOT_ENOUGH_FUNDS_FOR_TG_LICENSE_EMAIL = 'NOT_ENOUGH_FUNDS_FOR_TG_LICENSE_EMAIL',
  // PAYKEEPER_EMAIL_NOTIFICATIONS
  PAYKEEPER_PAYMENT_EMAIL = 'PAYKEEPER_PAYMENT_EMAIL',
  // STRIPE_EMAIL_NOTIFICATIONS
  STRIPE_TOP_UP_BALANCE_EMAIL = 'STRIPE_TOP_UP_BALANCE_EMAIL',
  // BALANCE_EMAIL_NOTIFICATIONS
  OVERDRAFT_STATUS_EMAIL = 'OVERDRAFT_STATUS_EMAIL',
  BALANCE_DROPPED_BELOW_THRESHOLD_EMAIL = 'BALANCE_DROPPED_BELOW_THRESHOLD_EMAIL',
  RICH_BALANCE_LIMIT_EMAIL = 'RICH_BALANCE_LIMIT_EMAIL',
  // TENANT_ACCESS_EMAIL_NOTIFICATIONS
  TENANT_ACCESS_EMAIL = 'TENANT_ACCESS_EMAIL',
}

export enum EMailingConfig {
  RETRY_CONFIG = 'RETRY_CONFIG',
  BALANCE_THRESHOLD_CONFIG = 'BALANCE_THRESHOLD_CONFIG',
}

type TRepeatConfig = {
  name: EMailingConfig.RETRY_CONFIG;
  repeatCount: number;
  repeatDuration: string | 0;
};

type TBalanceConfig = {
  name: EMailingConfig.BALANCE_THRESHOLD_CONFIG;
  limits: Record<ECurrency, number>;
};

export type TMailing = {
  subcategory: EMailingSubcategory;
  channelType?: EChannelType;
  settings: {
    recipients: string[];
    configs?: {
      [EMailingConfig.RETRY_CONFIG]: TRepeatConfig;
      [EMailingConfig.BALANCE_THRESHOLD_CONFIG]: TBalanceConfig;
    };
  };
};

export type TMailingCategory = {
  category: EMailingsCategory;
  subcategories: TMailing[];
};

export type TMailingPayload = {
  recipients: string[];
  subcategory: EMailingSubcategory;
  configs: (TRepeatConfig | TBalanceConfig)[] | null;
};

export type TMailingFormData = {
  email?: string;
  recipients: string[];
  subcategory: EMailingSubcategory;
  settings: {
    hasRepeat: boolean | null;
    repeatDuration?: number | null;
    repeatCount: number | null;
    limit?: number | null;
  };
};

export type TCompanyLead = {
  id: TItemId;
  name: string;
  login: string;
  role: ERoles;
};

export type TCompanyUser = {
  id: TItemId;
  name: string;
  login: string;
  role: ERoles;
  locked: boolean;
};
